import FullWidthHeaderAdvanced from "@components/BasicComponents/FullWidthHeader/FullWidthHeaderAdvanced"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import {getPosts} from "@config/modules"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import CustomerStories from "@jsons/customerStories.json"
import StudioFeatures from "@jsons/studioFeature.json"
import StudioOverview from "@jsons/studioOverview.json"
import CustomersSection from "@pages/Studio/FeaturesPage/CustomersSection/CustomersSection"
import FeatureSection from "@pages/Studio/FeaturesPage/FeatureSection/FeatureSection"
import FormSection from "@pages/Studio/FeaturesPage/FormSection/FormSection"
import React from "react"

type Props = {}

const features = (props: Props) => {
	const pageData = getTranslatedPageData(StudioFeatures, undefined, true)
	const list = getValueOrThrow(pageData.AdvancedSideAsset)

	getTranslatedPageData(StudioOverview, true)

	const stories = getPosts("CustomerStoriesModule", {data: CustomerStories})

	return (
		<>
			<HeadMeta meta={pageData.metaData} />

			<FullWidthHeaderAdvanced
				data={getValueOrThrow(pageData.heroData)}
				withOverlay
			/>
			<FeatureSection
				activeIndex={0}
				cardDirection={"left"}
				data={list[1]}
				direction={"left"}
				linkPanel={getValueOrThrow(list[0].mainContent)}
			/>

			<FeatureSection
				activeIndex={1}
				cardDirection={"right"}
				data={list[2]}
				direction={"right"}
				linkPanel={getValueOrThrow(list[0].mainContent)}
			/>

			<FeatureSection
				activeIndex={2}
				cardDirection={"left"}
				data={list[3]}
				direction={"left"}
				linkPanel={getValueOrThrow(list[0].mainContent)}
			/>
			<FeatureSection
				activeIndex={3}
				cardDirection={"right"}
				data={list[4]}
				direction={"right"}
				linkPanel={getValueOrThrow(list[0].mainContent)}
			/>
			<FeatureSection
				activeIndex={4}
				cardDirection={"left"}
				data={list[5]}
				direction={"left"}
				linkPanel={getValueOrThrow(list[0].mainContent)}
			/>

			<CustomersSection data={stories} />

			<FormSection />
		</>
	)
}

export default features
